export default __webpack_public_path__ + "marker-shadow.a0c6cc1401c107b501ef.png";